import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Dropdown } from 'antd';
import "./style.scss";
import { GATEIO, MEXC, PANCAKE, TWITTER_URL, REDIT_URL, FACE_URL, YOUTUBE_URL, TELEGRAM_URL, DOCS_URL, LAUNCHPAD, DEFAI, NFT_URL, XCONNECT } from "../../const/const";
import { useLocation } from "react-router-dom";


const Header: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isEcosystemOpen, setIsEcosystemOpen] = useState(false);
  const [isBuyBSCSOpen, setIsBuyBSCSOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();


  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const toggleEcosystem = () => {
    setIsBuyBSCSOpen(false);
    setIsEcosystemOpen(!isEcosystemOpen);
  };
  const toggleBuyBSCS = () => {
    setIsEcosystemOpen(false);
    setIsBuyBSCSOpen(!isBuyBSCSOpen);
  };

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  }

  const handleNavClick = (id: string, path: string = "/") => {
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        scrollToSection(id);
      }, 100);
    } else {
      scrollToSection(id);
    }
  };

  return (
    <>
      <div className="header-mobile flex space-between">
        <Link to="/" className="main-logo">
          <img alt='' src='/images/header/bscs.svg' />
        </Link>
        <img
          className="open-menu-logo"
          alt=''
          src={`/images/header/${isMobileMenuOpen ? 'close' : 'mobile-icon'}.svg`}
          onClick={toggleMobileMenu}
        />
      </div>
      {isMobileMenuOpen && (
        <div className="mobile-menu-overlay">
          <div className="mobile-menu">
            <div className="mobile-menu-header">
              <Link to="/" className="main-logo">
                <img alt='' src='/images/header/bscs.svg' />
              </Link>
              <img
                className="close-menu-logo"
                alt=''
                src='/images/header/close.svg'
                onClick={toggleMobileMenu}
              />
            </div>
            <div className="mobile-menu-content">
              <div className="mobile-menu-item ecosystem-dropdown" onClick={toggleEcosystem}>
                Our Ecosystem
                <img
                  className={`dropdown-arrow ${isEcosystemOpen ? 'open' : ''}`}
                  alt=''
                  src='/images/header/drop.svg'
                />
              </div>
              {isEcosystemOpen && (
                <div className="mobile-ecosystem-content">
                  <div className="app-link" onClick={() => window.open(LAUNCHPAD)}>
                    <div className="title">
                      <img className="logo" alt='' src='/images/header/rocket.svg' />
                      <h4>LAUNCHPAD</h4>
                      <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                    </div>
                    <p className="desc">Launch your project with BSCS's multichain platform — a secure and scalable gateway for IDOs and INOs.</p>
                  </div>
                  <div className="app-link" onClick={() => window.open(NFT_URL)}>
                    <div className="title">
                      <img className="logo" alt='' src='/images/header/nft.svg' />
                      <h4>NFT MARKETPLACE</h4>
                      <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                    </div>
                    <p className="desc">Trade, collect, and explore NFTs across BSC in a seamless, user-friendly NFT hub.</p>
                  </div>
                  <div className="app-link" onClick={() => window.open(DEFAI)}>
                    <div className="title">
                      <img className="logo" alt='' src='/images/header/defai.svg' />
                      <h4>DEFAI</h4>
                      <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                    </div>
                    <p className="desc">AI-powered DeFi terminal that simplifies crypto trading and analytics with intelligent, real-time insights.</p>
                  </div>
                  <div className="app-link" onClick={() => window.open(XCONNECT)}>
                    <div className="title">
                      <img className="logo" alt='' src='/images/header/trade.svg' />
                      <h4>XConnect (SocialFi & Airdrop Platform)</h4>
                      <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                    </div>
                    <p className="desc">Earn rewards by engaging on X (Twitter). Boost your rank, visibility, and airdrop chances through SocialFi.</p>
                  </div>
                  <div className="border-top"></div>
                  <div className="border-bottom"></div>
                  <div className="follow">
                    <div className="border-top"></div>
                    <div className="border-bottom"></div>
                    <h4>Follow us on:</h4>
                    <div className="flex link-group">
                      <div className="link" onClick={() => window.open(TELEGRAM_URL)}>
                        <img alt='' src='/images/header/telegram.svg' />
                        <p>Telegram</p>
                        <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                      </div>
                      <div className="link" onClick={() => window.open(TWITTER_URL)}>
                        <img alt='' src='/images/header/x.svg' />
                        <p>X.com</p>
                        <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                      </div>
                      <div className="link" onClick={() => window.open(REDIT_URL)}>
                        <img alt='' src='/images/home/partners/reddit.svg' />
                        <p>Reddit</p>
                        <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                      </div>
                      <div className="link" onClick={() => window.open(FACE_URL)}>
                        <img alt='' src='/images/home/partners/fb.svg' />
                        <p>Facebook</p>
                        <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                      </div>
                      <div className="link" onClick={() => window.open(YOUTUBE_URL)}>
                        <img alt='' src='/images/home/partners/youtube.svg' />
                        <p>Youtube</p>
                        <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                      </div>
                      {/* <div className="link">
                        <img alt='' src='/images/header/discord.svg' />
                        <p>Discord</p>
                        <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                      </div> */}
                    </div>
                  </div>
                </div>
              )}
              <div onClick={() => {
                handleNavClick("solutions");
                setIsMobileMenuOpen(false);
              }} className="mobile-menu-item">Solutions</div>
              {/* <Link to="#" className="mobile-menu-item">Developers</Link> */}
              <div className="mobile-menu-item ecosystem-dropdown" onClick={toggleBuyBSCS}>
                Buy $BSCS
                <img
                  className={`dropdown-arrow ${isBuyBSCSOpen ? 'open' : ''}`}
                  alt=''
                  src='/images/header/drop.svg'
                />
              </div>
              {isBuyBSCSOpen && (
                <div className="mobile-ecosystem-content">
                  <div onClick={() => window.open(MEXC)} className="app-link">
                    <div className="title">
                      <img className="logo" alt='' src='/images/header/mexc.svg' />
                      <h4>MEXC</h4>
                      <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                    </div>
                    <p className="desc">Mexc.com</p>
                  </div>
                  <div onClick={() => window.open(PANCAKE)} className="app-link">
                    <div className="title">
                      <img className="logo" alt='' src='/images/header/pancake.png' />
                      <h4>PancakeSwap</h4>
                      <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                    </div>
                    <p className="desc">Pancakeswap.finance</p>
                  </div>
                  <div onClick={() => window.open(GATEIO)} className="app-link">
                    <div className="title">
                      <img className="logo" alt='' src='/images/header/gate.svg' />
                      <h4>Gate.io</h4>
                      <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                    </div>
                    <p className="desc">Gate.io</p>
                  </div>
                </div>
              )}
              <div onClick={() => {
                handleNavClick("community");
                setIsMobileMenuOpen(false);
              }} className="mobile-menu-item">Community</div>
              {/* <div className="start-btn">
                <span>GET STARTED</span> <img alt='' src='/images/header/arrow-right-1.svg' />
              </div> */}
            </div>
          </div>
        </div>
      )}
      <div className="header-layout">
        <div className="layout">
          <div className="inner-layout">
            <header className="header">
              <nav className="header-inner">
                <Link to="/" className="main-logo">
                  <img alt='' src='/images/header/bscs.svg' />
                </Link>
                <div className="menu">
                  <Dropdown
                    overlay={
                      <div className="flex-dropdown custom-dropdown-menu">
                        <div className="left">
                          <a href={LAUNCHPAD} target="_blank" className="app-link">
                            <div className="title">
                              <img className="logo" alt='' src='/images/header/rocket.svg' />
                              <h4>LAUNCHPAD</h4>
                              <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                            </div>
                            <p className="desc">Launch your project with BSCS's multichain platform — a secure and scalable gateway for IDOs and INOs.</p>
                            <div className="number">
                              <p>01</p>
                              <img alt='' src='/images/home/partners/square.svg' />
                            </div>
                          </a>
                          <a href={DEFAI} target="_blank" className="app-link">
                            <div className="title">
                              <img className="logo" alt='' src='/images/header/defai.svg' />
                              <h4>DEFAI</h4>
                              <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                            </div>
                            <p className="desc">AI-powered DeFi terminal that simplifies crypto trading and analytics with intelligent, real-time insights.</p>
                            <div className="number">
                              <p>03</p>
                              <img alt='' src='/images/home/partners/square.svg' />
                            </div>
                          </a>
                        </div>
                        <div className="center">
                          <a href={NFT_URL} target="_blank" className="app-link">
                            <div className="title">
                              <img className="logo" alt='' src='/images/header/nft.svg' />
                              <h4>NFT MARKETPLACE</h4>
                              <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                            </div>
                            <p className="desc">Trade, collect, and explore NFTs across BSC in a seamless, user-friendly NFT hub.</p>
                            <div className="number">
                              <p>02</p>
                              <img alt='' src='/images/home/partners/square.svg' />
                            </div>
                          </a>
                          <a href={XCONNECT} target="_blank" className="app-link">
                            <div className="title">
                              <img className="logo" alt='' src='/images/header/trade.svg' />
                              <h4>XConnect (SocialFi & Airdrop Platform)</h4>
                              <img className="arrow" alt='' src='/images/header/arrow-right.svg' />
                            </div>
                            <p className="desc">Earn rewards by engaging on X (Twitter). Boost your rank, visibility, and airdrop chances through SocialFi.</p>
                            <div className="number">
                              <p>04</p>
                              <img alt='' src='/images/home/partners/square.svg' />
                            </div>
                          </a>
                        </div>
                        <div className="right">
                          <div className="follow">
                            <div className="border-top"></div>
                            <div className="border-bottom"></div>
                            <h4>Follow us on:</h4>
                            <a href={TELEGRAM_URL} target="_blank" className="link">
                              <img alt='' src='/images/header/telegram.svg' />
                              <p>Telegram</p>
                              <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                            </a>
                            <a href={TWITTER_URL} target="_blank" className="link">
                              <img alt='' src='/images/header/x.svg' />
                              <p>X.com</p>
                              <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                            </a>
                            <a href={REDIT_URL} target="_blank" className="link">
                              <img alt='' src='/images/home/partners/reddit.svg' />
                              <p>Reddit</p>
                              <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                            </a>
                            <a href={FACE_URL} target="_blank" className="link">
                              <img alt='' src='/images/home/partners/fb.svg' />
                              <p>Facebook</p>
                              <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                            </a>
                            <a href={YOUTUBE_URL} target="_blank" className="link">
                              <img alt='' src='/images/home/partners/youtube.svg' />
                              <p>Youtube</p>
                              <img className="arrow" alt='' src='/images/header/arrow_up_right.svg' />
                            </a>
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <div className="drop-title">
                      <p className="menu-title">Our Ecosystem</p>
                      <img alt='' src='/images/header/drop.svg' />
                      <div className="line"></div>
                    </div>
                  </Dropdown>
                  <div className="drop-title">
                    <div onClick={() => handleNavClick('solutions')} className="menu-title">
                      Solutions
                    </div>
                  </div>
                  {/* <div className="drop-title">
                    <Link className="menu-title" to="#">
                      Developers
                    </Link>
                  </div> */}
                  <Dropdown
                    placement="bottomCenter"
                    overlay={
                      <div className="flex-dropdown-buy-bscs">
                        <div className="bscs">
                          <div className="border-top"></div>
                          <img alt='' src='/images/header/bscs-1.svg' />
                          <div className="border-bottom"></div>
                        </div>
                        <div onClick={() => window.open(MEXC)} className="trade">
                          <img className="logo" alt='' src='/images/header/mexc.svg' />
                          <div className="content">
                            <div className="title">
                              <p>Mexc</p>
                              <img alt='' src='/images/header/arrow-right.svg' />
                            </div>
                            <p className="web">Mexc.com</p>
                          </div>
                        </div>
                        <div onClick={() => window.open(PANCAKE)} className="trade">
                          <img className="logo" alt='' src='/images/header/pancake.png' />
                          <div className="content">
                            <div className="title">
                              <p>PancakeSwap</p>
                              <img alt='' src='/images/header/arrow-right.svg' />
                            </div>
                            <p className="web">Pancakeswap.finance</p>
                          </div>
                        </div>
                        <div onClick={() => window.open(GATEIO)} className="trade">
                          <img className="logo" alt='' src='/images/header/gate.svg' />
                          <div className="content">
                            <div className="title">
                              <p>Gate.io</p>
                              <img alt='' src='/images/header/arrow-right.svg' />
                            </div>
                            <p className="web">Gate.io</p>
                          </div>
                        </div>
                      </div>
                    }
                  >
                    <div className="drop-title">
                      <p className="menu-title">Buy $BSCS</p>
                      <img alt='' src='/images/header/drop.svg' />
                      <div className="line"></div>
                    </div>
                  </Dropdown>
                  <div className="drop-title">
                    <div onClick={() => handleNavClick('community')} className="menu-title">
                      Community
                    </div>
                  </div>
                </div>
                {/* <div className="start-btn">
                  <span>GET STARTED</span> <img alt='' src='/images/header/arrow-right-1.svg' />
                </div> */}
              </nav>
            </header>
          </div>
        </div>
      </div>
    </>
  );
};

export default Header;
